import * as React from 'react';

function SvgCfp(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 144 61"
      {...props}>
      <path
        fill="#434343"
        d="M143.506 24.376c0 1.69-.387 3.276-1.171 4.755-.757 1.48-1.956 2.671-3.607 3.574q-2.436 1.355-6.172 1.355h-5.083v12.124h-6.079V14.605h11.172q3.516 0 5.996 1.268c1.651.846 2.878 2.008 3.69 3.488.839 1.48 1.264 3.151 1.264 5.024zm-11.208 4.573c1.679 0 2.924-.394 3.736-1.172q1.218-1.227 1.218-3.392c0-3.074-1.651-4.62-4.954-4.62h-4.825v9.184zM116.654 14.605v5.11h-12.806v8.096h9.807v5.023h-9.807v13.35h-6.156V14.605zM61.35 30.409c0-3.035.69-5.75 2.081-8.146 1.42-2.424 3.328-4.294 5.735-5.619 2.436-1.353 5.169-2.039 8.18-2.039 3.52 0 6.607.883 9.264 2.66 2.647 1.766 4.497 4.218 5.552 7.347h-7.269c-.72-1.475-1.745-2.584-3.069-3.317q-1.941-1.111-4.516-1.109c-1.842 0-3.482.433-4.92 1.288-1.42.826-2.532 2.01-3.347 3.542-.786 1.531-1.17 3.335-1.17 5.402s.393 3.834 1.17 5.403c.815 1.531 1.928 2.724 3.347 3.589q2.172 1.24 4.92 1.24c1.716 0 3.222-.366 4.516-1.109 1.324-.77 2.35-1.888 3.07-3.363h7.268c-1.055 3.157-2.906 5.618-5.552 7.394-2.618 1.738-5.706 2.612-9.264 2.612-3.011 0-5.735-.667-8.18-1.992a15.23 15.23 0 0 1-5.735-5.618c-1.38-2.387-2.08-5.102-2.08-8.146z"
      />
      <path
        fill="url(#cfp_svg__a)"
        d="M50.014.82c0-.746-.918-1.104-1.422-.552l-7.007 7.709a19.93 19.93 0 0 0-11.598-3.713c-8.802 0-16.276 5.687-18.957 13.595a19.9 19.9 0 0 1 8.99-2.137c11.058 0 20.028 8.974 20.028 20.049a20 20 0 0 1-1.065 6.454c6.54-3.298 11.03-10.077 11.03-17.912V.819"
      />
      <path
        fill="url(#cfp_svg__b)"
        d="M9.966 24.313c0-2.258.378-4.427 1.065-6.454C4.501 21.152.016 27.915 0 35.73v23.452c0 .745.918 1.102 1.422.551l6.96-7.656a19.93 19.93 0 0 0 11.645 3.744c8.802 0 16.276-5.687 18.957-13.595a19.9 19.9 0 0 1-8.99 2.137c-11.058 0-20.028-8.974-20.028-20.049"
      />
      <defs>
        <radialGradient
          id="cfp_svg__a"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(-46.539 108.814 116.368)scale(146.702 504.884)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0.75} stopColor="#FFE800" />
          <stop offset={0.77} stopColor="#ECE205" />
          <stop offset={0.81} stopColor="#BCD412" />
          <stop offset={0.87} stopColor="#6EBD28" />
          <stop offset={0.95} stopColor="#009D48" />
        </radialGradient>
        <radialGradient
          id="cfp_svg__b"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(-41.145 70.867 17.021)scale(110.456 137.572)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0.05} stopColor="#22397C" />
          <stop offset={0.08} stopColor="#255292" />
          <stop offset={0.13} stopColor="#2974B0" />
          <stop offset={0.18} stopColor="#2D8EC8" />
          <stop offset={0.24} stopColor="#2FA1D9" />
          <stop offset={0.29} stopColor="#31ADE3" />
          <stop offset={0.35} stopColor="#32B1E7" />
        </radialGradient>
      </defs>
    </svg>
  );
}
export default SvgCfp;
